import { h } from 'preact';
import Scrollable from '../../../../common/hoc/scrollable';

function SlidableSlide({ children, scrollable = true }) {
  return !scrollable ? children : (
    <Scrollable>
      {children}
    </Scrollable>
  );
}

export default SlidableSlide;
